export const BREAKPOINT_XS = 576
export const BREAKPOINT_SM = 769
export const BREAKPOINT_MD = 992
export const BREAKPOINT_LG = 1199
export const BREAKPOINT_XL = 1600
